import axios from 'axios'
import config from '../../config'

const client = axios.create({
  baseURL: process.env.NODE_ENV == 'development' ? config.dev.api_url : config.build.api_url,
  timeout: 15000,
});

export default client;


// WEBPACK FOOTER //
// ./src/services/http.js